module.exports = __webpack_public_path__ + "static/media/partners--bg.339c48cf.jpg";